import IlSignupStoryLibAdapter from './IlSignupStoryLibAdapter.vue';

export function initializeIlSignupIntegration() {
  if (typeof window === 'undefined') {
    return;
  }

  if (!window.IlSignupComponentRegistry) {
    setTimeout(() => {
      initializeIlSignupIntegration();
    }, 100);
    return;
  }

  try {
    window.IlSignupComponentRegistry.register(IlSignupStoryLibAdapter);
  } catch (error) {
    // eslint-disable-next-line no-console
  }
}

export function isIlSignupIntegrationActive() {
  return (
    typeof window !== 'undefined'
    && window.IlSignupComponentRegistry
    && window.IlSignupComponentRegistry.hasComponent()
  );
}

export function unregisterIlSignupIntegration() {
  if (typeof window !== 'undefined' && window.IlSignupComponentRegistry) {
    window.IlSignupComponentRegistry.unregister();
  }
}

if (typeof window !== 'undefined') {
  setTimeout(() => {
    initializeIlSignupIntegration();
  }, 0);
}

export default {
  initializeIlSignupIntegration,
  isIlSignupIntegrationActive,
  unregisterIlSignupIntegration,
};
